export default __webpack_public_path__ + "static/media/emailtemp.5016a0c7.jpg";